// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.login-page {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #f4f5f7;
}
.login-page__card {
  text-align: center;
  background: #fff;
  border-radius: 10px;
  padding: 48px 40px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  max-width: 380px;
  width: 100%;
}
.login-page__logo {
  width: 180px;
  margin-bottom: 24px;
}
.login-page__msg {
  color: #6d6e71;
  font-size: 15px;
  margin-bottom: 28px;
}
.login-page__btn {
  background: #69be28;
  color: #fff;
  border: none;
  border-radius: 6px;
  padding: 12px 40px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  transition: background 0.2s;
}
.login-page__btn:hover {
  background: #00add0;
}`, "",{"version":3,"sources":["webpack://./src/app/components/login/login.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,iBAAA;EACA,mBAAA;AACF;AACE;EACE,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kBAAA;EACA,0CAAA;EACA,gBAAA;EACA,WAAA;AACJ;AAEE;EACE,YAAA;EACA,mBAAA;AAAJ;AAGE;EACE,cAAA;EACA,eAAA;EACA,mBAAA;AADJ;AAIE;EACE,mBAAA;EACA,WAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,2BAAA;AAFJ;AAII;EACE,mBAAA;AAFN","sourcesContent":[".login-page {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 100vh;\n  background: #f4f5f7;\n\n  &__card {\n    text-align: center;\n    background: #fff;\n    border-radius: 10px;\n    padding: 48px 40px;\n    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);\n    max-width: 380px;\n    width: 100%;\n  }\n\n  &__logo {\n    width: 180px;\n    margin-bottom: 24px;\n  }\n\n  &__msg {\n    color: #6d6e71;\n    font-size: 15px;\n    margin-bottom: 28px;\n  }\n\n  &__btn {\n    background: #69be28;\n    color: #fff;\n    border: none;\n    border-radius: 6px;\n    padding: 12px 40px;\n    font-size: 16px;\n    font-weight: 600;\n    cursor: pointer;\n    transition: background 0.2s;\n\n    &:hover {\n      background: #00add0;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
